module.exports = __webpack_public_path__ + "img/reference-federmannsaal.fa247172.jpg";